import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Kindred from './pages/Kindred';
import { MetaTags } from './components/MetaTags';
import { SchemaOrg } from './components/SchemaOrg';
// import { QueryParamRemover } from './components/QueryParamRemover';

const App: React.FC = () => {
  return (
    <Router>
      <MetaTags />
      <SchemaOrg />
      {/* <QueryParamRemover /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kindred" element={<Kindred />} />
      </Routes>
    </Router>
  );
};

export default App;
